import React from 'react'
import { Box, Button, Typography } from '@mui/material'
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos'
import dompurify from 'dompurify'
import { FormattedMessage, useIntl } from 'react-intl'
import SeoNewsSlug from '../seo/SeoNewsSlug'
import { useSelector } from 'react-redux'
import { IReducer, LangType } from 'src/interface'
import { IntlLink } from './IntlComponents'

const changeLinks = (htmlText: string, lang: LangType): string => {
  if (!htmlText) {
    return ''
  }

  const langPrefix = lang === 'en' ? '' : `/${lang}`
  // Replace https://gemvision.com with http://localhost:3000 and add lang prefix
  const updatedHtml = htmlText.replace(/(<a[^>]+href=["'])https:\/\/gemvision\.com(\/(en|es))?/g, `$1${langPrefix}`)

  const splitHtml = updatedHtml.split('<a')
  let newHtml = splitHtml[0]
  for (let i = 1; i < splitHtml.length; i++) {
    newHtml += `<a target='_blank' rel='noopener noreferrer'${splitHtml[i]}`
  }
  return newHtml
}

export default function WhatsNewBlog({ blog, backUrl, buttonId }: { blog: any; backUrl: string; buttonId: string }) {
  const intl = useIntl()
  const lang = useSelector((state: IReducer) => state.changeLanguage.lang)
  const sanitizer = (dirty: any) => dompurify.sanitize(dirty, { ADD_TAGS: ['iframe'] })
  return (
    <>
      <SeoNewsSlug
        title={blog.title}
        description={blog.custom_excerpt ?? intl.formatMessage({ id: 'seo.news.description' })}
        slug={blog.slug}
      />
      <Box className='news-details-wrapper'>
        <Typography mb={2}>
          {new Date(blog.published_at).toLocaleDateString('en-US', {
            day: 'numeric',
            month: 'long',
            year: 'numeric'
          })}
        </Typography>
        <Typography component='h1' variant='h1' mb={4}>
          {blog.title}
        </Typography>
        <img src={blog.feature_image} alt={blog.title} />
        <div
          data-gtm-click-section='News Blog'
          data-gtm-click-subsection1={blog.title}
          key={blog.id}
          className='news-details'
          dangerouslySetInnerHTML={{ __html: sanitizer(changeLinks(blog.html, lang)) }}
        />
        <Box pt={2} mt={6} sx={{ borderTop: '1px solid #444' }}>
          <Button size='large' color='secondary' component={IntlLink} to={backUrl} startIcon={<ArrowBackIosIcon />}>
            <FormattedMessage id={buttonId} />
          </Button>
        </Box>
      </Box>
    </>
  )
}
